import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Identity Systems", desc: "Logo, typography, and color systems shaped for memory, clarity, and trust." },
  { title: "Campaign Visuals", desc: "Ad and launch assets designed for channel-native performance and consistency." },
  { title: "Sales Collateral", desc: "Decks, brochures, and one-pagers that support high-stakes conversations." },
  { title: "Social Design", desc: "Scalable creative templates that keep your presence coherent and recognizable." },
  { title: "Product Graphics", desc: "UI visuals, onboarding assets, and feature imagery that improve comprehension." },
  { title: "Production Quality", desc: "Export standards, print readiness, and reusable source systems for internal teams." },
];

const GraphicDesign = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Design crafted for"
    titleAccent="business impact."
    subtitle="Visual communication that sharpens positioning, strengthens campaigns, and accelerates decision-making."
    features={features}
    ctaLabel="START CREATIVE WORK"
  />
);

export default GraphicDesign;